import React, { FunctionComponent } from "react";

import { LocalizationProvider, Text } from "@multiweb/reactComponents";
import { LOC_NO_PARAMETERS_NEEDED } from "../../../../../../locKeys";

export const NewObjectPage: FunctionComponent = () => (
    <LocalizationProvider locKey={LOC_NO_PARAMETERS_NEEDED} >
        {({ text }) => (
            <Text value={text} />
        )}
    </LocalizationProvider>
);
